import { FC } from 'react'
import { Row } from 'react-bootstrap'

const PageNotFound: FC = () => {
  return <Row className="p-4">Page Not Found</Row>
}

export default PageNotFound
